export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "fileUpload": {
          "browserNotSupport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your browser does not support embedded videos."])},
          "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download"])}
        }
      },
      "ru": {
        "fileUpload": {
          "browserNotSupport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ваш браузер не поддерживает встроенные видео."])},
          "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скачать"])}
        }
      },
      "es": {
        "fileUpload": {
          "browserNotSupport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tu navegador no admite videos incrustados."])},
          "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar"])}
        }
      },
      "kk": {
        "fileUpload": {
          "browserNotSupport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сіздің браузеріңіз кірістірілген бейнелерді қолдамайды."])},
          "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жүктеу"])}
        }
      },
      "uz": {
        "fileUpload": {
          "browserNotSupport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brauzeringiz o‘rnatilgan videolarni qo‘llab-quvvatlamaydi."])},
          "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yuklab olish"])}
        }
      },
      "de": {
        "fileUpload": {
          "browserNotSupport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ihr Browser unterstützt keine eingebetteten Videos."])},
          "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Herunterladen"])}
        }
      },
      "fr": {
        "fileUpload": {
          "browserNotSupport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Votre navigateur ne prend pas en charge les vidéos intégrées."])},
          "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Télécharger"])}
        }
      },
      "it": {
        "fileUpload": {
          "browserNotSupport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il tuo browser non supporta i video incorporati."])},
          "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scarica"])}
        }
      }
    }
  })
}
